import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "view",
  "use": "view-usage",
  "viewBox": "0 0 24 25",
  "content": "<symbol viewBox=\"0 0 24 25\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"view\"><path d=\"M3.75 11.705s3-5.667 8.25-5.667 8.25 5.667 8.25 5.667-3 5.667-8.25 5.667-8.25-5.667-8.25-5.667z\" stroke=\"#702F73\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path d=\"M12 13.83c1.243 0 2.25-.951 2.25-2.125S13.243 9.58 12 9.58s-2.25.951-2.25 2.125S10.757 13.83 12 13.83z\" stroke=\"#702F73\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./icons/view.svg
// module id = 166
// module chunks = 0